import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModerationFilesManagement } from '../../../../../models';
import useModerationContext from '../../../../../context/useModerationContext';
import { Button, Card, ContentCard, ToastContext } from '@weezevent/nacre';

import { UploadDropZone } from '../../../../../nacre/uploadButton';
import { UploadPreviewFile } from '../../../../../components/upload/components/uploadPreview';
import LoadingCard from '../../../../../components/loadingCard';

import css from '../filesManagement.module.css';

export default function UploadZone({ organizationId, flowId }) {
    const { t } = useTranslation();
    const [{ syncActiveTab }] = useModerationContext();
    const toast = React.useContext(ToastContext);
    const [file, setFile] = React.useState([]);
    const [error, setError] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    const handleSelect = React.useCallback((files, rejected) => {
        if (!rejected.length) {
            setError(null);
            return setFile(files);
        }
        return setError(rejected[0].errors[0]);
    }, []);

    const handleUpload = React.useCallback(() => {
        setLoading(true);
        ModerationFilesManagement.uploadFile({
            organizationId,
            flowId,
            file: file[0]
        })
            .catch(() => {
                toast.error(t('ticket.common.toast_error'));
            })
            .then(() => {
                const timeout = setTimeout(() => {
                    setLoading(false);
                    setFile([]);
                    setError(null);
                    syncActiveTab();
                }, 1000);

                return () => clearTimeout(timeout);
            });
    }, [organizationId, flowId, file, syncActiveTab]);

    return (
        <Card>
            <Card.Header>
                <Card.Title title={t('ticket.moderation.filesManagement.uploadZone.title')} />
                <Card.SubTitle title={t('ticket.moderation.filesManagement.uploadZone.subtitle')} />
            </Card.Header>
            <ContentCard>
                <LoadingCard loading={loading}>
                    <div className={css['upload-zone']}>
                        {!file.length ? (
                            <UploadDropZone
                                acceptedFileExtensions={['.csv']}
                                label={t('ticket.moderation.filesManagement.uploadZone.description')}
                                onFileSelected={(files, rejected) => handleSelect(files, rejected)}
                            />
                        ) : (
                            <UploadPreviewFile onDelete={() => setFile([])} fileSrc={file[0]?.path} isUploadedS3={false} displayDate={false} />
                        )}
                        {error && <div className={'dropzone-error-over-limit'}>{t('ticket.event.dropzone_error_file_invalid_type')}</div>}
                    </div>
                </LoadingCard>

                <Button primary disabled={!file.length || error || loading} onClick={handleUpload}>
                    {t('ticket.common.action.import')}
                </Button>
            </ContentCard>
        </Card>
    );
}
